// API de acuses de entrega (firma del cliente + PDF).
import { api } from './api'
import type { Acuse, DataResponse } from '@/types'

export type { Acuse }

export interface AcusePayload {
  items_delivered: string[]
  observations?: string | null
  client_name: string
  client_signature_b64: string // dataURL PNG del canvas
  driver_signature_b64?: string | null
}

export async function createAcuse(deliveryId: string, payload: AcusePayload) {
  const { data } = await api.post<DataResponse<Acuse>>(`/deliveries/${deliveryId}/acuse`, payload)
  return data.data
}

export async function getAcuse(deliveryId: string): Promise<Acuse | null> {
  try {
    const { data } = await api.get<DataResponse<Acuse>>(`/deliveries/${deliveryId}/acuse`)
    return data.data
  } catch {
    return null // 404 => aún no hay acuse
  }
}

